import { HttpContextToken } from '@angular/common/http';

/**
 * Explicitly opts a request out of the back-office authentication interceptor.
 * Citizen and public APIs share the same origin in development but use
 * independent sessions, so the decision belongs to the core HTTP boundary.
 */
export const SKIP_ADMIN_AUTH = new HttpContextToken<boolean>(() => false);
